__turbopack_context__.v({
  "rights": "Footer-module-scss-module__ryesnq__rights",
  "wrapper": "Footer-module-scss-module__ryesnq__wrapper",
});
